/**
 * アップデート情報（旧 /updateinfo）を移した共有ノートの公開セクションのタイトル。
 * BE の移行コマンド `migrate_updateinfo_to_notes` が作成するセクション名と一致させる。
 */
export const UPDATE_INFO_SECTION_TITLE = "Update Info";
